export default __webpack_public_path__ + "90919ac8a4aae9c6357183b55b07c74c.svg";